import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

class TitleController implements angular.IController {
    displayName: string;
    
    static $inject = ['$scope', '$state'];

    constructor(private _$scope: angular.IScope,
        private _$state: angular.ui.IStateService) {
    }

    $onInit() {
        this._$scope.$watchCollection(() => this._$state.current.data, () => {
                const data = this._$state.current.data;
                this.displayName = data.displayName;
            }
        );
    }
}

export const WtTitle: DirectiveDefinition = {
    directiveId: 'wtTitle',
    restrict: 'AE',
    controller: TitleController,
    controllerAs: 'vm',
    bindToController: true,
    template: require('./title.directive.html'),
    transclude: true,
    scope: {
    }
};